export default __webpack_public_path__ + "static/media/image27.19168ed7.png";